import { render, staticRenderFns } from "./CustomerGridModal.vue?vue&type=template&id=64da19f0"
import script from "./CustomerGridModal.vue?vue&type=script&lang=js"
export * from "./CustomerGridModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerGridModal.vue?vue&type=style&index=0&id=64da19f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports